import React, { useEffect } from "react";

// Filesystem hook
import { useFilesystem } from "../../../contexts/SandboxHooks";

// Monaco themes hook
import { useMonacoThemes } from "../../../../../../hooks/useMonacoThemes";

// Lazy load local wrapper for Monaco Editor
const MonacoLocal = React.lazy(() => import("./MonacoLocal"));

import S from "./_styles.module.scss";
import EditorSkeleton from "./EditorSkeleton";

const Editor = () => {
  const { monacoTheme, handleEditorMount } = useMonacoThemes();

  // Access the filesystem context and get the first file to display
  const {
    currentLanguage,
    fileLookup,
    beginEditingFile,
    editor: { currentPath: currentEditorPath, currentContents: currentEditorContents },
    handleEditorChange,
  } = useFilesystem();
  const firstFilePath = fileLookup ? Object.keys(fileLookup)[0] : null;

  useEffect(() => {
    if (firstFilePath && !currentEditorPath) {
      beginEditingFile(firstFilePath);
    }
  }, [firstFilePath, currentEditorPath, beginEditingFile]);

  return (
    <div className={S.container}>
      {currentEditorContents !== null && (
        <React.Suspense fallback={<EditorSkeleton />}>
          <MonacoLocal
            height="100%"
            language={currentLanguage}
            value={currentEditorContents}
            onChange={handleEditorChange}
            theme={monacoTheme}
            className={S.editor}
            onMount={handleEditorMount}
          />
        </React.Suspense>
      )}
    </div>
  );
};

export default Editor;
